import React, { memo } from 'react';
import { Button, Table, Form } from 'react-bootstrap';
import { formatCurrency } from '../../helpers/order';
import { PRODUCT_TYPES } from '../../utils/constants';
import { createFormatter } from '../../helpers/formatters';
import getProductType from '../../helpers/getProductType';

const OrderItemsTable = ({
  canEdit,
  cart,
  editedItems,
  editing,
  handleCancelEdit,
  handleEditToggle,
  handleSaveChanges,
  onQuantityChange,
  order,
  orderProductsAddedAfter,
  sortedCartItems,
}) => (
  <div className="table-container top-table-container">
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>SKU</th>
          <th>Nombre del producto</th>
          <th>Precio Unidad</th>
          <th>Cantidad</th>
          <th>Monto Total</th>
          <th>Comentarios</th>
        </tr>
      </thead>
      <tbody>
        {!!cart &&
          sortedCartItems.map((item) => {
            const product = order.products.find(
              (p) => p.product_id === item.product_id
            );
            const sku = product ? product.sku : 'SKU no encontrado';
            const pesokgField = product?.custom_fields?.find(
              (f) => f.name === 'pesokg'
            );
            const tipoField = product?.custom_fields?.find(
              (f) => f.name === 'tipo' && f.value === 'Kg'
            );
            const isEditItem = !!editedItems[item.product_id];
            const inputValue = isEditItem
              ? pesokgField
                  ? editedItems[item.product_id].selected_weight
                  : editedItems[item.product_id].quantity
              : pesokgField
              ? item.selected_weight
              : item.quantity || 0;

            const isKg = tipoField && tipoField.value === 'Kg';

            const pricePerUnit = item.sale_price
              ? item.sale_price
              : item.non_sale_price;
            const isAddedAfter = item.cart_item_id?.startsWith('added-');

            return (
              <tr key={item.cart_item_id}>
                <td
                  style={
                    isAddedAfter
                      ? { borderRight: '5px solid darkcyan' }
                      : undefined
                  }
                >
                  {sku}
                </td>
                <td>{`${
                  isKg && !pesokgField
                    ? item.custom_name
                    : `${item.quantity} ${item.custom_name}`
                }`}</td>
                <td>{formatCurrency(pricePerUnit)}</td>
                <td>
                  {editing ? (
                    <Form.Control
                      type="number"
                      value={inputValue}
                      min="0"
                      step={isKg ? '0.01' : '1'}
                      onChange={(e) => {
                        let value = parseFloat(e.target.value) || 0;
                        if (!isKg) {
                          value = Math.round(value);
                        }
                        onQuantityChange(item.product_id, value);
                      }}
                    />
                  ) : (
                    inputValue
                  )}
                </td>
                <td>{formatCurrency(item.price)}</td>
                <td>{item.comment || ''}</td>
              </tr>
            );
          })}
        {!!orderProductsAddedAfter?.length &&
          orderProductsAddedAfter.map((product) => {
            const {
              name,
              sku,
              quantity,
              base_price,
              total_inc_tax,
              custom_fields,
            } = product;
            const type = getProductType(custom_fields);
            const formatter = createFormatter();
            const isKg =
              PRODUCT_TYPES.KILOGRAM === type &&
              !custom_fields.some(({ name }) => name === 'pesokg');

            return (
              <tr key={product.id}>
                <td style={{borderRight: '5px solid darkcyan'}}>{sku}</td>
                <td>{`${isKg ? name : `${quantity} ${name}`}`}</td>
                <td>{formatter.format(+base_price)}</td>
                <td>{quantity}</td>
                <td>{formatter.format(+total_inc_tax)}</td>
                <td>{''}</td>
              </tr>
            );
          })}
      </tbody>
    </Table>
    <div className="d-flex justify-content-center">
      {!!canEdit && (
        <>
          {editing ? (
            <>
              <Button
                variant="primary"
                onClick={handleSaveChanges}
                className="mt-3"
                style={{ marginRight: '12px' }}
              >
                Guardar
              </Button>
              <Button
                variant="secondary"
                onClick={handleCancelEdit}
                className="mt-3 ml-2"
              >
                Cancelar
              </Button>
            </>
          ) : (
            <Button
              variant="primary"
              onClick={handleEditToggle}
              className="mt-3"
            >
              Editar
            </Button>
          )}
        </>
      )}
    </div>
  </div>
);

export default memo(OrderItemsTable);
